// extracted by mini-css-extract-plugin
export default {"overlay":"vy-z","bodyOpen":"wy-z","content":"xy-z","header":"yy-z","close":"zy-z","closeNoHeading":"Ay-z"};